import { setPreference } from '@fs/zion-preferences'
import { useStatusOverlay } from '@fs/zion-ui'
import { useEffect, useRef } from 'react'

export default function OptInV2(): null {
  const showStatusOverlay = useStatusOverlay()
  const hasOptedIn = useRef(false)

  useEffect(() => {
    if (hasOptedIn.current) return

    hasOptedIn.current = true
    setPreference('tree.newMerge2', true)
      .then(() => {
        // TODO translations
        showStatusOverlay({ message: 'You have opted in to the new merge experience.' })
        return undefined
      })
      .catch(() => {
        showStatusOverlay({
          message: 'There was an error opting in to the new merge experience. Please try again later.',
        })
      })
  }, [showStatusOverlay])

  return null
}
